import React from 'react';
import { app } from '../Reports/values/ui';

const Error = ({ customMessage }) => {
  return (
    <div className="reportsNoStudentsNotice">
      <div>{customMessage || "Error generating report"} </div>
      {app.errorHelpPrompt}
    </div>
  );

}
export default Error;